<template>
  <div v-if="options && options.length" :class="prefix+'-popver-content'">
    <div :class="prefix+'-multiCascader-multil-content'">
      <ul v-if="expandTrigger==='click'">
        <li
          v-for="(item, index) of options"
          :key="index"
          :value="item.value"
          :class="{active: number===index, disabled: item.disabled}"
          @click.stop="changeResult(item, index)"
        >
          {{ item.label }}
          <t-icon v-if="(item.children && item.children.length > 0 || item.loading === false)" icon="chevron-right-outline" class="arrowRight"></t-icon>
          <t-icon v-if="tmpItem && tmpItem.loading && (tmpItem.value === item.value)" icon="loading" :class="mainPrefix+'ani-loop'"></t-icon>
        </li>
      </ul>
      <ul v-if="expandTrigger==='hover'">
        <li
          v-for="(item, index) of options"
          :key="index"
          :value="item.value"
          :class="{active: number===index, disabled: item.disabled}"
          @mouseover="hoverChange(item, index, $event)"
          @click.stop="changeResult(item, index)"
        >
          {{ item.label }}
          <t-icon v-if="(item.children && item.children.length > 0 || item.loading === false)" icon="chevron-right-outline" class="arrowRight"></t-icon>
          <t-icon v-if="tmpItem && tmpItem.loading && (tmpItem.value === item.value)" icon="loading" :class="mainPrefix+'ani-loop'"></t-icon>
        </li>
      </ul>
    </div>
    <multi-menu v-if="sublist && sublist.length" :options="sublist" :expand-trigger="expandTrigger"></multi-menu>
  </div>
</template>

<script>
import bus from '../../utils/bus'
import Emitter from '../../mixins/emitter'
import { findComponentUpward } from '../../utils/assist'
import { PREFIX_CLASS } from '@/utils/constants'

export default {
  name: 'MultiMenu',
  mixins: [Emitter],
  props: {
    options: {
      type: Array,
      default() {
        return []
      }
    },
    expandTrigger: {
      type: String,
      validator(value) {
        return ['click', 'hover'].includes(value)
      },
      default: 'click'
    }
  },

  data() {
    return {
      mainPrefix: PREFIX_CLASS,
      prefix: `${PREFIX_CLASS}cascading`,
      tmpItem: null,
      level: 1,
      sublist: [],
      number: ''
    }
  },

  computed: {

  },

  watch: {
    options() {
      this.sublist = []
    }
  },

  mounted() {
    this.$on('on-find-selected', params => {
      let value = [...params.value]
      for (let i = 0; i < value.length; i++) {
        for (let j = 0; j < this.options.length; j++) {
          if (value[i] === this.options[j].value) {
            this.changeResult(this.options[j], true)
            value.splice(0, 1)
            this.$nextTick(() => {
              this.broadcast('MultiMenu', 'on-find-selected', {
                value: value
              })
            })
            return false
          }
        }
      }
    })
  },

  methods: {
    hoverChange(item, index) {
      if (item && !item.children) return
      this.changeResult(item, index)
    },

    changeResult(item, index) {
      if (item.disabled) return
      let menu = this.$children[0]
      if (menu) {
        menu.number = ''
        menu.sublist = []
      }
      this.number = index
      let baseItem = this.getBaseItem(item)
      this.tmpItem = baseItem
      if (item.loading !== undefined && !item.children.length) {
        const cascader = findComponentUpward(this, 'TCascading')
        if (cascader && cascader.loader) {
          this.tmpItem.loading = true
          cascader.loader(item, () => {
            this.tmpItem.loading = false
            this.changeResult(item, index)
          })
          return
        }
      }
      this.renderSubMenu(item, baseItem)
    },
    renderSubMenu(item, baseItem) {
      this.sublist = []
      let lastValue = false
      if (item.children && item.children.length > 0) {
        this.sublist = item.children
      } else {
        lastValue = true
      }
      this.passDataToParent(lastValue, baseItem)
      this.setMenuLevel()
    },
    passDataToParent(lastValue, baseItem) {
      bus.$emit('selectedCurrentValue', {
        fromInit: false,
        lastValue: lastValue,
        self: this,
        baseItem: baseItem,
        level: this.level
      })
      bus.$emit('updateCurrentValue', {
        fromInit: false,
        lastValue: lastValue,
        self: this
      })
    },
    setMenuLevel() {
      let panel = null
      this.$nextTick(() => {
        panel = this.$children.find(item => {
          return item.$options && item.$options._componentTag && /multi-menu/ig.test(item.$options._componentTag)
        })
        if (panel) {
          panel.level = this.level + 1
        }
      })
    },
    getBaseItem(item) {
      let baseItem = Object.assign({}, item)
      if (baseItem.children) {
        delete baseItem.children
      }
      return baseItem
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/new-cascader/menu.vue